<template>
    <div class="title">
        <h2>{{ title }}</h2>

        <!-- Button Events -->
        <template v-if="btnAction">
        <div v-for="(action, index) in btnAction" :key="index" @click="event(action)" class="title-btn">
            <i class="icon-btn material-icons">{{ action.options.icon }}</i>
            <span>{{ action.options.label }}</span>
        </div>
        </template>

        <!-- Back -->
        <template v-if="form">
            <div @click="$router.go(-1)" class="title-btn">
                <i class="icon-btn material-icons">arrow_back</i>
                <span>Voltar</span>
            </div>
        </template>

        <!-- Menu -->
        <template v-if="classificar">
            <div @click="$router.push('/')" class="title-btn">
                <i class="icon-btn material-icons">arrow_back</i>
                <span>Menu</span>
            </div>
        </template>

    </div>
</template>

<style lang="stylus" scoped>

    @import '../../style/colors.styl';
    @import '../../style/fonts.styl';
    @import '../../style/mixins.styl';
    @import '../../style/spacing.styl';

    .title-btn-back
      background-color red

    .title
        margin-top space-md
        margin-bottom space-md
        display flex
        flex-wrap wrap
        align-items center
        justify-content space-between
        gap space-md

        > h2
            font-family Rubik-Medium
            margin 0
            flex-shrink 0
            font-size 1.75rem

        > span
            font-family Manrope-Bold

        .title-btn
            margin-left space-sm
            background linear-gradient(135deg, accent 0%, darken(accent, 10%) 100%)
            color white
            border-radius radius-md
            padding space-sm space-md
            cursor pointer
            transition all transition-base
            display inline-flex
            align-items center
            gap space-xs
            box-shadow shadow-sm
            white-space nowrap

            &:hover
                background linear-gradient(135deg, primary 0%, #FF7A29 100%)
                transform translateY(-1px)
                box-shadow shadow-orange

            &:active
                transform translateY(0)

            span, .icon-btn
                vertical-align middle
                no-select()

    // Tablet and below
    @media (max-width: 991px)
        .title
            > h2
                font-size 1.5rem

            .title-btn
                padding space-xs space-sm
                font-size 0.9rem

    // Mobile
    @media (max-width: 768px)
        .title
            flex-direction column
            align-items flex-start
            gap space-md

            > h2
                font-size 1.35rem
                width 100%

            .title-btn
                margin-left 0
                width 100%
                justify-content center

    // Small mobile
    @media (max-width: 576px)
        .title
            > h2
                font-size 1.25rem

            .title-btn
                padding space-sm
                font-size 0.85rem

                .icon-btn
                    font-size 18px

</style>

<script>

/**
 * Component Holder - Title
 *
 * Display page title and has a button in right
 *
 * Events:
 *   - Button in right (no suffix needed)
 *       + Options:
 *           - label(String)
 *           - icon(String)
 *
 * Props:
 *   - Page Title (title)
 */

import Action from '@/mixins/core/ActionBehavior'
import Event from '@/mixins/core/EventBehavior'

export default {
  mixins: [Action, Event],
  data: () => ({ actionsScope: 'Title' }),
  props: {
    title: { type: String, default: 'No Title' },
    form: { type: Boolean, default: false },
    classificar: { type: Boolean, default: false }
  },
  computed: {
    btnAction () {
      return this.actions.slice(0, 2)
    }
  }
}
</script>
